export default {
  width: 96,
  height: 96,
  padding: 24,
  float: 'right'
}



// WEBPACK FOOTER //
// ./src/styles/buttons/icon.js